import PropTypes from 'prop-types';

import React from 'react';

class ReportViewer extends React.Component {
  static propTypes = {
    url: PropTypes.string,
  };

  render() {
    let height = Math.max(500, window.innerHeight - 200);

    return <div className='reportviewer-wrapper'>
      <iframe src={this.props.url}
              frameBorder="0"
              width='910'
              height={height}/>
    </div>;
  }
}

export default ReportViewer;
